import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { LoginService } from '../components/login/login.service'
import { routes } from '../../app/routes.constant';
import { UserService } from '../services/user.service';
import { nodeTypes } from '../../app/app-constant';

@Injectable()
export class AuthGuard implements CanActivate {
  
  lastRoute: String;

  setLastRoute(routePath) {
    localStorage.setItem('latsRoute', routePath);
    this.lastRoute = routePath;
  }

  getLastRoute() {
    if(!this.lastRoute) {
      this.lastRoute = localStorage.getItem('lastRoute');
    }
	  return this.lastRoute;
  }

  constructor(private loginService: LoginService, private router: Router, private userService: UserService) {}
  
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    //console.log('Inside AuthGuard '+state.url);

    let stateUrl = state.url.split('?')[0];
    if(stateUrl != routes.LOGIN && stateUrl != routes.LOGIN_AUTH && stateUrl != routes.DIGITAL_HUB && this.loginService.loggedIn && 
      (stateUrl != routes.USERS || (stateUrl == routes.USERS && this.userService.nodeType == nodeTypes.ADMIN)) && 
      (stateUrl != routes.CREATE_CLIENT || (stateUrl == routes.CREATE_CLIENT && this.userService.nodeType == nodeTypes.ADMIN))) {
      this.setLastRoute(stateUrl);
      return true;
    } else if((stateUrl == routes.LOGIN || stateUrl == routes.LOGIN_AUTH || stateUrl == routes.DIGITAL_HUB) && !this.loginService.loggedIn) {
      return true;
    } else {
      //console.log(this.loginService.loggedIn, this.getLastRoute());
      if(this.loginService.loggedIn) {
        let landingRoute = this.loginService.getLandingRoute();
        this.router.navigate([landingRoute]);
      }
      return false;
    }
  }
}
